import React, { Suspense } from 'react';
import { useUserSettingsContext } from '../context/UserSettingsContext';

// The enforcement UI (phone input, QR codes, passkey setup) is only needed
// by orgs that enforce MFA; everyone else never downloads it.
const MfaEnforcementGuard = React.lazy(() => import('./MfaEnforcementGuard'));

export default function MfaGuardGate() {
  const { currentOrganization } = useUserSettingsContext();
  const policy = currentOrganization?.mfaPolicy;
  if (!policy?.enforced || !(policy.allowedMethods || []).length) return null;
  return (
    <Suspense fallback={null}>
      <MfaEnforcementGuard />
    </Suspense>
  );
}
